<template>
	<div class="user-dashboard">
		<UserMenu/>
		<div class="main-panel">
			<TopNav/>
			<Outages />
			<div class="content">
<!--				<div class="row">-->
<!--					<div class="col-md-12">-->
<!--						<Alert :type="alertType" :message="alertMessage" v-if="alertShow === true"/>-->
<!--						<div class="card" v-if="asyncDone === false">-->
<!--							&lt;!&ndash; Show the loader when async operation is going on &ndash;&gt;-->
<!--							<div class="loader"></div>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
        <disk-space-alert v-if="showDiskAlert" :showLink="true"/>
				<div class="row flex-row" >
					<ActiveDomainsList v-if="!isCollaborator" :accounts="accountsOrdered"/>
					<PendingDomainsList v-if="!isCollaborator" :accounts="accountsOrdered"/>
					<SupportTicketsList v-if="!isCollaborator" :accounts="activeAccounts"/>
					<Collaborations />
					<DiskSpace/>
					<NotificationList />
				</div>
				<div class="row" v-if="migrationCardDismiss !== true && !isCollaborator">
					<div class="col-12">
						<div class="card">
							<button type="button" aria-label="Close" class="close text-red text-right mr-3 mt-3" title="Dismiss the card" @click="dismissMigrationCard">
								<span aria-hidden="true">×</span>
							</button>
							<div class="card-header text-center">
								<div class="card-title">
									<h2 class="text-primary mb-0">Looking to migrate from your old host?</h2>
								</div>
								<p class="card-category" style="text-transform: none;">Spend a few minutes providing us with your site(s) and old host’s details, and we’ll handle the rest!</p>
							</div>
							<div class="card-body text-center mb-5">
								<router-link v-if="accountsOrdered.length > 0" :to="{ name: 'requestMigration' }" class="btn btn-lg btn-primary">
									Place a Migration Request
								</router-link>
								<router-link v-else :to="{ name: 'addSite', query: {toMigrate: 0} }" class="btn btn-lg btn-primary">
									Place a Migration Request
								</router-link>
							</div>
						</div>
					</div>
				</div>
<!--				<transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">-->
<!--					-->
<!--				</transition>-->
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2';

	export default {
		name: "userDashboard",
		components: {
			UserMenu: () =>
				import(/* webpackChunkName: "userMenu" */ "../../components/User/SideMenu.vue"),
			TopNav: () =>
				import(/* webpackChunkName: "topNav" */ "../../components/TopNav.vue"),
			Alert: () =>
				import(/* webpackChunkName: "alert" */ "../../components/Alerts.vue"),
			ActiveDomainsList: () =>
				import(/* webpackChunkName: "activeDomainsList" */ "../../components/User/Dashboard/ActiveDomainsList.vue"),
			PendingDomainsList: () =>
				import(/* webpackChunkName: "pendingDomainsList" */ "../../components/User/Dashboard/PendingDomainsList.vue"),
			SupportTicketsList: () =>
				import(/* webpackChunkName: "supportTicketsList" */ "../../components/User/Dashboard/SupportTicketsList.vue"),
			DiskSpace: () =>
				import(/* webpackChunkName: "supportTicketsList" */ "../../components/User/Dashboard/DiskSpace.vue"),
            NotificationList: () =>
                import(/* webpackChunkName: "supportTicketsList" */ "../../components/User/Dashboard/NotificationList.vue"),
			Outages: () =>
					import(/* webpackChunkName: "supportTicketsList" */ "../../components/Helps/OutageBanner.vue"),
			Collaborations: () =>
					import(/* webpackChunkName: "supportTicketsList" */ "../../components/User/Dashboard/Collaborations.vue"),
      DiskSpaceAlert: () =>
					import(/* webpackChunkName: "supportTicketsList" */ "../../components/Helps/DiskSpaceAlert.vue")
		},
		data() {
			return {
				migrationCardDismiss: null,
      };
		},
		computed: {
			isShowNotificationOnLogIn() {
				return this.$store.getters.isShowNotificationOnLoggedIn;
			},
			UID() {
				return this.$store.getters.getUID;
			},
			asyncDone() {
				return this.$store.getters["async/state"];
			},
			alertType() {
				return this.$store.getters["alert/type"];
			},
			alertMessage() {
				return this.$store.getters["alert/message"];
			},
			alertShow() {
				return this.$store.getters["alert/show"];
			},
			activeAccounts() {
				return this.$store.getters["hosting/activeAccounts"];
			},
			accountsOrdered() {
				return this.$store.getters["hosting/accountsOrdered"];
			},
			pendingAccounts() {
				return this.$store.getters["hosting/pendingAccounts"];
			},
      customerID() {
        return this.$store.getters.getCustomerID;
      },
      isCollaborator () {
        return this.accountsOrdered.length <= 0 && this.customerID === '-1'
      },
      showDiskAlert() {
        return this.$store.getters["alert/showDiskAlert"];
      },
      user() {
        return this.$store.getters.user;
      }
		},
		methods: {
			fetchHostingAccounts() {
				// Load all the hosting accounts for the user
				this.$store.dispatch("hosting/fetchAccounts");
			},
			dismissMigrationCard() {
				swal({
					title: "Are you sure?",
					text: "Are you sure that you want to close this info card about migration details and link?",
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				})
					.then(result => {
						if (result.value) {
							this.migrationCardDismiss = true;
							localStorage.setItem("dismissMigrationCard", "true");
						}
					})
			},
			migrationCardDismissed() {
				this.migrationCardDismiss = Boolean(
					localStorage.getItem("dismissMigrationCard")
				);
			}
		},
		created() {
			// localStorage.setItem('loginAsUser', '');
			this.fetchHostingAccounts();
			this.migrationCardDismissed();
			// if(this.isShowNotificationOnLogIn){
			// 	console.log('showing notifications...');
			// 	this.$store.dispatch('notification/resetNotifications');
			// 	this.$store.dispatch('notification/fetchNotifications');
			// 	this.$store.commit('updateShowNotificationOnLogIn', false);
			// }

		}
	};
</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>

<style lang="scss">
	.nounderline {
		text-decoration: none;

		&:hover {
			text-decoration: none;
		}
	}

	button {
		&.close {
			&:focus {
				outline: none;
			}
		}
	}
	.hm400{
		height: 450px !important;
	}
	.slimScrollDiv {
		height: auto !important;
	}
	.scroll-area {
		position: relative;
		max-height: 300px;
		/*overflow: hidden;*/
	}
	.list-group-item:focus, .list-group-item:hover{
		z-index: 0;
	}
	li:last-child.list-group-item {
		border-bottom: none;

	}
</style>
